import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  iconColumn: {
    fontSize: pxToRem(18),
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    paddingTop: pxToRem(3),
  },
  actionIndicator: {
    height: pxToRem(20),
    textAlign: 'center',
    fontSize: pxToRem(20),
    color: theme.palette.red,
    paddingTop: pxToRem(3),
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: pxToRem(16),
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: pxToRem(16),
    verticalAlign: 'middle',
    marginLeft: pxToRem(6),
    color: theme.palette.neutralPrimary,
  },
});
